import Typography from "@material-ui/core/Typography";
import * as React from "react";
import {withStyles} from "@material-ui/core";
import {RadioAccordionStyle} from "@components/common/radioAccordion/radioAccordion.style";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import clsx from "clsx";

interface IRadioAccordionProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    classes: any;
    label: React.ReactNode;
    helpInfo?: React.ReactNode;
    error?: string | undefined;
}

interface IRadioAccordionState {
    isFocused: boolean;
}

class RadioAccordion extends React.Component<IRadioAccordionProps, IRadioAccordionState> {
    private radioRef: React.RefObject<HTMLInputElement>;

    constructor(props: IRadioAccordionProps) {
        super(props);
        this.radioRef = React.createRef();

        this.state = {
            isFocused: false,
        };
        this.handleRadioBlur = this.handleRadioBlur.bind(this);
        this.handleRadioFocus = this.handleRadioFocus.bind(this);
    }

    public render() {
        const {id, key, label, helpInfo, classes, error, ...rest} = this.props;
        const {isFocused} = this.state;
        const showHelpInfo = this.props.checked;
        const radioClassName = [];
        if (error) {
            radioClassName.push(classes.invalidRadio);
        }
        if(isFocused) {
            radioClassName.push(classes.focusedRadio);
        }

        const labelTextClassName = this.props.checked ? classes.checkedLabelText : '';

        return (
            <div className={classes.root}>
                <div className={classes.radioContainer}>
                    <label
                        htmlFor={id}
                        key={key}
                        className={classes.label}
                    >
                        <input
                            {...rest}
                            ref={this.radioRef}
                            id={id}
                            className={clsx([classes.radio, ...radioClassName])}
                            type="radio"
                            onBlur={this.handleRadioBlur}
                            onFocus={this.handleRadioFocus}
                        />
                        <Typography className={`${classes.labelText} ${labelTextClassName}`}>{label}</Typography>
                    </label>
                </div>
                {showHelpInfo && (
                    <div className={classes.helpInfo}>
                        {helpInfo}
                    </div>
                )}
            </div>
        );
    }

    private handleRadioBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        this.setState({
            isFocused: false,
        });
        const radioElement = this.radioRef.current;
        if (radioElement) {
            radioElement.reportValidity(); // Trigger HTML radio validity check
        }

        if (this.props.onBlur) {
            this.props.onBlur(event);
        }
    }

    private handleRadioFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        this.setState({
            isFocused: true,
        });

        if (this.props.onFocus) {
            this.props.onFocus(event);
        }
    }
}

export default withStyles(RadioAccordionStyle)(RadioAccordion);



// WEBPACK FOOTER //
// ./src/components/common/radioAccordion/radioAccordion.component.tsx